/**
 * AAStar Community Branding Configuration
 */

export const BRANDING = {
  logo: "https://raw.githubusercontent.com/jhfnetboy/MarkDownImg/main/img/202505031325963.png",
  icon: "https://www.aastar.io/favicon.ico",
  colors: {
    primary: "#FF6B35",
    primaryLight: "#FF8C42",
    secondary: "#4A90E2",
    secondaryDark: "#357ABD",
    success: "#4CAF50",
    warning: "#FFC107",
    error: "#F44336",
    gray50: "#F9FAFB",
    gray100: "#F3F4F6",
    gray700: "#374151",
    gray800: "#1F2937",
    gray900: "#111827",
  },
} as const;

export const LINKS = {
  main: "https://aastar.io",
  airAccount: "https://airAccount.aastar.io",
  superPaymaster: "https://superpaymaster.aastar.io",
  demo: "https://aastar.io/demo",
  github: "https://github.com/AAStarCommunity",
  discord: "https://discord.gg/aastar",
  twitter: "https://twitter.com/AAStarCommunity",
} as const;
